import { FC } from "react";
import { RequestItem } from "@/shared/requests-item";
import { Box, Stack } from "@mui/material";
import {
  EmptyDataPlaceholder,
  EmptyDataPlaceholderProps,
} from "../../../shared/ui/empty-data-placeholder";

import { DealRequest } from "@/app/api/types";

interface Props {
  data: DealRequest[];
  emptyPlaceholderProps: EmptyDataPlaceholderProps;
  type?: "seller" | "buyer" | "factor";
}

export const RequestsList: FC<Props> = ({
  data,
  emptyPlaceholderProps,
  type = "seller",
}) => {
  return (
    <EmptyDataPlaceholder {...emptyPlaceholderProps}>
      <Box>
        <Stack spacing={2}>
          {data.map((r) => (
            <RequestItem key={r.unique} data={r} to={r.unique} type={type} />
          ))}
        </Stack>
      </Box>
    </EmptyDataPlaceholder>
  );
};
